import Form from "components/forms/layout";
import React from "react";
import styles from "./AccountConfiguration.module.scss";

interface Props {
  image: React.ReactNode;
  landscapeImage?: React.ReactNode;
  name: React.ReactNode;
}

export const AccountInfoLayout = (props: Props) => {
  const { image, name, landscapeImage } = props;
  return (
    <div className={styles["info"]}>
      <Form.Input className={styles["image"]}>{image}</Form.Input>
      {landscapeImage && <Form.Input className={styles["landscape-image"]}>{landscapeImage}</Form.Input>}
      <Form.Input className={styles["name"]}>{name}</Form.Input>
    </div>
  );
};
